/*
 * File: IconButton.styles.js
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:59 PM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: July 20, 2022 at 4:04 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Button = styled.button`
 	display: flex;
 	appearance: none;
 	border: none;
 	background-color: transparent;
 	color: inherit;
 	cursor: pointer;

 	&:hover {
	 	opacity: 0.8;
 	}

 	svg {
	 	width: ${({ $size }) => $size}rem !important;
	 	height: ${({ $size }) => $size}rem !important;
 	}
`;
